import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import InsuranceCompanyAddOperation from './InsuranceCompanyAddOperation';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	insuranceId: string;
	rootWorkplaceId: string;
	onCreate: () => void;
}

const InsuranceCompanyAddOperationModal: React.FC<Props> = props => {
	return (
		<BaseModal
			title='component.insuranceCompanyAddOperation.title'
			size={Size.MD}
			{...props}>
			<InsuranceCompanyAddOperation
				insuranceId={props.insuranceId}
				rootWorkplaceId={props.rootWorkplaceId}
				onCreate={props.onCreate}
			/>
		</BaseModal>
	);
};

export default InsuranceCompanyAddOperationModal;
